/* Crafteaze home page sections (ce-*) */
(function () {
  'use strict';

  var io = 'IntersectionObserver' in window;

  // Play a muted background video only while it is on screen and visible (desktop vs mobile copy)
  function initVideos(root) {
    var vids = (root || document).querySelectorAll('[data-ce-autoplay] video');
    vids.forEach(function (v) {
      if (v.dataset.ceBound) return;
      v.dataset.ceBound = '1';
      v.muted = true; v.loop = true; v.playsInline = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
      v.removeAttribute('controls');
      if (!io) { if (v.offsetParent) v.play().catch(function () {}); return; }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var visible = e.isIntersecting && v.offsetParent !== null;
          if (visible) { if (v.preload === 'none') v.preload = 'metadata'; v.play().catch(function () {}); }
          else { v.pause(); }
        });
      }, { threshold: 0.25 }).observe(v);
    });
  }

  // Reels arrows
  document.addEventListener('click', function (e) {
    var nav = e.target.closest('[data-ce-reels-nav]');
    if (nav) {
      var track = nav.closest('.ce-reels__wrap').querySelector('.ce-reels__track');
      var dir = nav.getAttribute('data-ce-reels-nav') === 'prev' ? -1 : 1;
      var card = track.firstElementChild;
      var step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
      var perView = Math.max(1, Math.floor((track.clientWidth + 1) / step));
      track.scrollBy({ left: dir * step * perView, behavior: 'smooth' });
      return;
    }
    // Review filter chips
    var chip = e.target.closest('[data-ce-filter]');
    if (chip) {
      var sec = chip.closest('.ce-reviews');
      sec.querySelectorAll('[data-ce-filter]').forEach(function (c) { c.classList.remove('is-on'); });
      chip.classList.add('is-on');
      var f = chip.getAttribute('data-ce-filter');
      sec.querySelectorAll('.ce-review').forEach(function (r) {
        r.style.display = (f === 'all' || r.getAttribute('data-ce-cat') === f) ? '' : 'none';
      });
    }
  });

  // Sticky mobile CTA: show after the first section, hide while the target section is on screen
  function initSticky() {
    var bar = document.querySelector('.ce-sticky');
    if (!bar || !io || bar.dataset.ceBound) return;
    bar.dataset.ceBound = '1';
    var first = document.querySelector('main .shopify-section, #MainContent .shopify-section');
    var target = document.querySelector(bar.getAttribute('data-hide-over') || '.ce-cats');
    var pastFirst = false, atTarget = false;
    function upd() { bar.classList.toggle('is-shown', pastFirst && !atTarget); }
    if (first) new IntersectionObserver(function (e) { pastFirst = !e[0].isIntersecting; upd(); }).observe(first);
    if (target) new IntersectionObserver(function (e) { atTarget = e[0].isIntersecting; upd(); }, { threshold: 0.1 }).observe(target);
  }

  // ---------- Reels: full-screen player ----------
  var soundOn = true;
  function openPlayer(card) {
    var track = card.closest('.ce-reels__track');
    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-ce-reel]'));
    var start = cards.indexOf(card);
    var ov = document.createElement('div');
    ov.className = 'ce-player';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.setAttribute('aria-label', 'Reels');
    ov.innerHTML =
      '<div class="ce-player__feed"></div>' +
      '<button type="button" class="ce-player__close" aria-label="Close">&times;</button>' +
      '<button type="button" class="ce-player__mute" aria-label="Sound on or off"></button>' +
      '<div class="ce-player__nav"><button type="button" data-dir="-1" aria-label="Previous reel">&#8593;</button><button type="button" data-dir="1" aria-label="Next reel">&#8595;</button></div>';
    var feed = ov.querySelector('.ce-player__feed');
    var vids = [];
    cards.forEach(function (c) {
      var src = c.querySelector('video');
      var slide = document.createElement('div');
      slide.className = 'ce-player__slide';
      var v = src.cloneNode(true);
      v.removeAttribute('data-ce-bound');
      v.removeAttribute('autoplay');
      v.removeAttribute('loop');
      v.loop = false; v.controls = false; v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.preload = 'metadata';
      slide.appendChild(v);
      var handle = c.getAttribute('data-handle');
      var link = c.getAttribute('data-link');
      var info = document.createElement('div');
      info.className = 'ce-player__info';
      info.innerHTML = '<span></span>' + (link ? '<a target="_blank" rel="noopener">View post &#8599;</a>' : '');
      info.querySelector('span').textContent = handle || '';
      if (link) info.querySelector('a').href = link;
      slide.appendChild(info);
      feed.appendChild(slide);
      vids.push(v);
    });

    var muteBtn = ov.querySelector('.ce-player__mute');
    function updMute() { muteBtn.innerHTML = soundOn ? '&#128266;' : '&#128263;'; }
    updMute();

    var current = -1;
    function playOnly(i) {
      vids.forEach(function (v, j) {
        if (j === i) {
          v.muted = !soundOn;
          if (v.preload !== 'auto') v.preload = 'auto';
          var p = v.play();
          if (p && p.catch) p.catch(function () { soundOn = false; updMute(); v.muted = true; v.play().catch(function () {}); });
        } else if (!v.paused) {
          v.pause();
        }
      });
      current = i;
    }
    function go(i) {
      i = Math.max(0, Math.min(vids.length - 1, i));
      feed.scrollTo({ top: i * feed.clientHeight, behavior: 'smooth' });
    }

    document.body.appendChild(ov);
    document.documentElement.classList.add('ce-lock');
    feed.scrollTop = start * feed.clientHeight;
    playOnly(start);

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && e.intersectionRatio >= 0.6) {
          var i = vids.indexOf(e.target.querySelector('video'));
          if (i !== current) { vids[i].currentTime = 0; playOnly(i); }
        }
      });
    }, { root: feed, threshold: [0.6] });
    Array.prototype.forEach.call(feed.children, function (s) { obs.observe(s); });

    vids.forEach(function (v, i) {
      v.addEventListener('ended', function () {
        if (i < vids.length - 1) go(i + 1); else { v.currentTime = 0; v.play().catch(function () {}); }
      });
      v.addEventListener('click', function () { if (v.paused) v.play().catch(function () {}); else v.pause(); });
    });

    function onKey(e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    }
    function close() {
      obs.disconnect();
      vids.forEach(function (v) { v.pause(); v.removeAttribute('src'); });
      ov.remove();
      document.documentElement.classList.remove('ce-lock');
      document.removeEventListener('keydown', onKey);
      card.focus && card.focus();
    }
    document.addEventListener('keydown', onKey);
    ov.querySelector('.ce-player__close').addEventListener('click', close);
    muteBtn.addEventListener('click', function () { soundOn = !soundOn; updMute(); if (vids[current]) vids[current].muted = !soundOn; });
    ov.querySelector('.ce-player__nav').addEventListener('click', function (e) {
      var b = e.target.closest('[data-dir]'); if (b) go(current + parseInt(b.getAttribute('data-dir'), 10));
    });
    ov.querySelector('.ce-player__close').focus();
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-ce-reel]');
    if (card) { e.preventDefault(); openPlayer(card); }
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('[data-ce-reel]')) { e.preventDefault(); openPlayer(e.target); }
  });

  function init(root) { initVideos(root); initSticky(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
/* Show the chosen colour name next to the option label (e.g. "COLOUR  Velvet · Sage/Yellow") */
(function () {
  function sync(fs) {
    var legend = fs.querySelector('.radio__legend');
    var checked = fs.querySelector('input[type="radio"]:checked');
    if (!legend || !checked) return;
    var tag = legend.querySelector('.ce-opt-name');
    if (!tag) { tag = document.createElement('span'); tag.className = 'ce-opt-name'; (legend.querySelector('.radio__legend__label') || legend).appendChild(tag); }
    tag.textContent = checked.value;
  }
  function init() {
    document.querySelectorAll('.form__wrapper[data-product-info] fieldset').forEach(function (fs) {
      if (!fs.querySelector('.swatch__input')) return;
      sync(fs);
      fs.addEventListener('change', function () { sync(fs); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();